<template>
  <div class="cube-page" :class="type">
    <header class="header">
      <div class="h-left" @click="back" v-if="isback">
        <van-icon size="20px" name="arrow-left"/>
      </div>
      <div class="h-title ells">{{title}}</div>
      <div class="h-right"  v-if="isback">
        <slot name="hright"></slot>
      </div>
      <!-- <h1 class="ells">{{title}}</h1>
      <i @click="back" v-if="isback" class="cubeic-back"><van-icon size='20px' name="arrow-left" /></i>
	  	<i class="cubeic-right">
			<slot name="hright"></slot> 
      </i>-->
    </header>
    <div class="wrapper">
      <section v-show="desc" class="desc">
        <slot name="desc">{{desc}}</slot>
      </section>
      <main class="content">
        <slot name="content">{{content}}</slot>
      </main>
    </div>
  </div>
</template>
	
<script>
import * as util from "@/utils/network";
export default {
  props: {
    title: {
      type: String,
      default: "",
      required: true
    },
    type: {
      type: String,
      default: ""
    },
    desc: {
      type: String,
      default: ""
    },
    content: {
      type: String,
      default: ""
    },
    isback: {
      type: Boolean,
      default: true
    },
    backurl: {
      type: String,
      default: ""
    },
    iswurl: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    back() {
      if (this.backurl.length > 1) {
        console.log(this.backurl);
        if (this.iswurl) {
          util.redirect(this.backurl);
        } else {
          this.$router.push(this.backurl);
        }
      } else {
        window.history.length > 1
          ? this.$router.back()
          : this.$router.push("/");
      }
    }
  }
};
</script>

<style scoped lang="less">
h1 {
  margin: 0;
}
.header {
  height: 44px;
  text-align: center;
  background-color: #edf0f4;
  box-shadow: 0 1px 6px #ccc;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  z-index: 5;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .h-title{
    flex: 1;
    text-align:center;
    font-size: 16px;
    font-weight: 700;
  }
  .h-left,.h-right {
    width: 50px;
    color: #6d189e;
  }
}
</style>

<style lang="stylus" rel="stylesheet/stylus">
.cube-page {
  position: absolute;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fafafa;

  // .header
  // position: relative
  // height: 44px
  // line-height: 44px
  // text-align: center
  // background-color: #edf0f4
  // box-shadow: 0 1px 6px #ccc
  // -webkit-backface-visibility: hidden
  // backface-visibility: hidden
  // z-index: 5
  // h1
  // font-size: 16px
  // font-weight: 700
  // .cubeic-back
  // position: absolute
  // top: 0
  // left: 0
  // padding: 5px 15px
  // color: #6d189e

  // .cubeic-right
  // position: absolute
  // top: 0
  // right: 0
  // padding: 5px 15px
  // color: #6d189e
  >.wrapper {
    height: calc(100% - 44px);
    overflow-x: hidden;
    overflow-y: auto;

    // -webkit-overflow-scrolling: touch
    .desc {
      padding: 10px;
      margin: 10px 0;
      line-height: 20px;
      font-size: 14px;
    }

    .content {
      // margin: 10px
    }
  }

  &.option-demo {
    .wrapper {
      background-color: $color-white;
    }

    .title {
      font-size: $fontsize-large;
      font-weight: 500;
      color: $color-dark-grey;
      padding: 15px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      margin-bottom: 15px;
    }

    .options {
      margin-bottom: 15px;
    }

    .option-list {
      .group {
        margin-bottom: 15px;
        border: 1px solid rgba(0, 0, 0, 0.1);
        border-radius: $radius-size-medium;
      }

      .item {
        height: 52px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);

        &.sub {
          font-size: $fontsize-medium;
          background-color: $color-light-grey-opacity;

          &.first {
            box-shadow: 0 1px 1px 1px #eee inset;
          }

          &.last {
            border-bottom: none;
          }
        }
      }
    }

    .demo {
      margin-bottom: 15px;
    }

    .methods {
      .method-list {
        .group {
          margin-bottom: 15px;
          border: 1px solid rgba(0, 0, 0, 0.1);
          border-radius: $radius-size-medium;
        }

        .item, button {
          height: 40px;
          font-size: $fontsize-large;
        }

        .item {
          background-color: $color-active-light-gray;
          border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        }

        button {
          width: 100%;
          border-bottom-left-radius: $radius-size-medium;
          border-bottom-right-radius: $radius-size-medium;
          background-color: $color-orange;
          box-shadow: 0 0 0 1px $color-orange;
          border: none;
          outline: none;
          color: $color-white;
        }
      }
    }
  }
}
</style>
